import React from 'react';
import PropTypes from 'prop-types';
import SpanningRowsGrid from '@amplify/spanning-rows-grid';
import { INDEX, CELL_MEASUREMENTS } from '../../../constants/shared/CellConstants';
import { SECTION_IDS, GRID } from '../../../constants/shared/CommonConstants';

const { PROGRESS_GRID } = SECTION_IDS;

const ProgressGrid = ({ colSpans, rows, gridKey, sortableColumns }) => (
    <div id={PROGRESS_GRID} className="grid-container-wrapper">
        <SpanningRowsGrid
            key={gridKey}
            colSpans={colSpans}
            stickyColumnList={[INDEX.FIRST_ARRAY_INDEX]}
            defaultCellMeasurements={CELL_MEASUREMENTS.DEFAULT}
            dataCellStyles={{}}
            subHeaderStyles={{}}
            areSubHeadersSticky
            scrollMode={GRID.SCROLL_MODE.CONTAINER}
            sortableColumns={sortableColumns}
        >
            {rows}
        </SpanningRowsGrid>
    </div>
);
ProgressGrid.defaultProps = {
    colSpans: [],
    rows: [],
    gridKey: null,
    sortableColumns: [],
};

ProgressGrid.propTypes = {
    colSpans: PropTypes.array,
    rows: PropTypes.array,
    gridKey: PropTypes.string,
    sortableColumns: PropTypes.array,
};

export default ProgressGrid;
